export const FieldType = {
	CHECKBOX: 'CHECKBOX',
	HOT_LABEL: 'HOT_LABEL',
	IMAGE: 'IMAGE',
	LABEL: 'LABEL',
	OTHER: 'OTHER',
	SECTION: 'SECTION',
	SINGLE: 'SINGLE',
	SINGLE_CASCADE: 'SINGLE_CASCADE',
	TEXT: 'TEXT',
	UNION_GOODS: 'UNION_GOODS'
}
